angular.module("Main").controller("AggregatorStep3Controller", ["$rootScope", "$scope", "$state", "$localStorage", "$uibModal", "$window", "$stateParams", "$location", "$translate", "DialogService", "ShopService", "PaymentService", "BookingService", "SessionService",
    function ($rootScope, $scope, $state, $localStorage, $uibModal, $window, $stateParams, $location, $translate, DialogService, ShopService, PaymentService, BookingService, SessionService) {
        var vm = this;

        if (!_.isEmpty($stateParams.club)) {
            vm.withoutClubsMenuItem = true;
            vm.mandantNr = $stateParams.club;
            loadAggregatorenConfig();
        } else {
            vm.withoutClubsMenuItem = false;
            vm.cookies = SessionService.checkSession();
            if (!_.isNil(vm.cookies.aggregatorClubData)) {
                vm.clubData = vm.cookies.aggregatorClubData;
                vm.aggregatorData = vm.cookies.aggregatorData;
                vm.mandantNr = vm.clubData.selectedMandantNr;
                vm.mandatBezeichnung = vm.clubData.selectedMandantName;
                loadAggregatorenConfig();
            }
        }

        function loadAggregatorenConfig() {
            vm.mandant = {MandantNr: vm.mandantNr, MandantBezeichnung: vm.mandatBezeichnung};
            BookingService.loadCodeText(vm.mandant, vm.aggregatorData).then(function (data) {
                vm.aggregatorenConfigtext = data;
            })
        }

        vm.accepted = false;
        vm.openedMenuBar = false;
        vm.errorRegisterDialog = false;

        vm.errorNotFound = false;
        vm.errorFound = false;
        vm.globalError = false;

        let abschliessen = false;
        vm.spinner = false;
        vm.showFormular = true;

        if (!SessionService.getSessionId()) {
            $state.go('aggregator_overview', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
        } else
            start();

        function start() {
            vm.cookies = SessionService.checkSession();
            vm.member = vm.cookies.aggregatorMemberData.Member;
            init();
            startRegisterStep();
        }

        loadConfigs();
        getKursbuchungLayouKonfiguration();
        loadOnlineSalesFarbenConfiguration();
        loadRegisterRequired();

        function loadRegisterRequired() {
            BookingService.loadRegisterReq().then(function (data) {
                vm.registrationRequiredFields = data;
            })
        }

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        $('#register-focus').autofocus;


        function init() {
            if (_.isNil(vm.cookies.aggregatorData) || _.isNil(vm.cookies.aggregatorData)) {
                if (!_.isEmpty($stateParams.club)) {
                    $state.go('aggregator_clubs', {cid: $stateParams.cid, id: $stateParams.id});
                } else {
                    $state.go('aggregator_overview', {cid: $stateParams.cid, id: $stateParams.id});
                }
            }
        }

        function loadConfigs() {
            BookingService.loadLayoutConfiguration().then(function (data) {
                vm.layoutSettings = angular.fromJson(data.Layout);
            });
        }

        function loadOnlineSalesFarbenConfiguration() {
            BookingService.getOnlineSalesLayout().then(function (data) {
                vm.layoutColors = angular.fromJson(data.Layout_Colors);
            })
        }

        vm.openPrivacyTerms = function () {
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/privacyTerms.html",
                controller: "BookingPrivacyTermsDialogController",
                controllerAs: "vm",
                resolve: {style: vm.layoutSettings[3]}
            });
        };

        vm.goToAngebot = function () {
            $state.go('aggregator_overview', {cid: $stateParams.cid, id: $stateParams.id});
            vm.openedMenuBar = false;
        };

        vm.openMenuBar = function () {
            if (vm.openedMenuBar === false) {
                vm.openedMenuBar = true;
            } else {
                vm.openedMenuBar = false;
            }
        };

        vm.sendCode = false;
        vm.startRegister = false;
        async function startRegisterStep () {

                vm.startRegister = true;
                vm.hasGeneralError = false;
                abschliessen = true;
                vm.spinner = true;
                vm.mandant = {MandantNr: vm.mandantNr, MandantBezeichnung: vm.mandatBezeichnung};
                BookingService.createTemporaryMemberAggregator(vm.member, vm.cookies.aggregatorData.Name, vm.mandant).then(function () {
                    vm.spinner = false;
                }).then(function () {
                    vm.spinner = false;
                    vm.sendCode = true;
                    vm.dataLoading = false;
                    vm.registerFinish = true;
                    vm.errorText = "LT_Es_wurde_email_geschickt";
                }).catch(function () {
                    vm.startRegister = false;
                    vm.sendCode = false;
                    vm.dataLoading = false;
                    vm.errorHeader = "T_Fehler";
                    vm.errorText = "LT_Bei_senden_der_Verifizierungsemail_ist_ein_Fehler_aufgetreten";
                });

        };

        vm.codeFalse = true;
        vm.codeChecked = false;
        vm.checkCode = function () {
            if (vm.sendCode && vm.verifizierungscode) {
                vm.setTan = true;
                vm.spinner = true;
                vm.member.code = vm.verifizierungscode;
                BookingService.checkRegisterCode(vm.member).then(function (temporaryMember) {
                    vm.spinner = false
                    if (temporaryMember.RightCode) {
                        vm.codeFalse = false;
                        vm.codeChecked = true;
                        $state.go('aggregator_tan', {sid: SessionService.getSessionId(), cid: $stateParams.cid, id: $stateParams.id});
                    } else {
                        vm.codeChecked = true;
                        vm.codeFalse = true;
                    }
                })
            }
        }

        vm.goBack = function () {
            $state.go('aggregator_register', {cid: $stateParams.cid, id: $stateParams.id, club: $stateParams.club});
        }

    }]);